import React, {Component} from "react";
import ContactAVKInt from "./img/Martin_Boersting.jpg";
import ContactAVKUK from "./img/David_Hurley.png";
import ContactAVKAnh from "./img/Kevin_Ouyang.png";
import ContactAVKSEA from "./img/Dinesh_picture.png";
import PropTypes from 'prop-types';
import {Col, Media} from "reactstrap";
import {Strings} from "./Strings";

export class ContactBlock extends Component {
    constructor(props) {
        super(props);
        this.contactPersons = [
            {
                name: "Martin Børsting",
                area: "AVK International",
                title: "Product Manager, Control Valves",
                email: "mabo@avk.dk",
                telephone: "+45 21337825",
                picture: ContactAVKInt
            },
            {
                name: "David Hurley",
                area: "AVK UK",
                title: "Technical Sales Manager - Control Valves",
                email: "dahu@avkuk.co.uk",
                telephone: "+44 7983 706675",
                picture: ContactAVKUK
            },
            {
                name: "Kevin Ouyang",
                area: "AVK Anhui",
                title: "Technical Marketing Manager",
                email: "kevin@avkanhui.com",
                telephone: "+86 555 5529 726",
                picture: ContactAVKAnh
            },
            {
                name: "Dinesh Thiagarajah",
                area: "AVK South East Asia",
                title: "Regional Product Manager",
                email: "dinesh@avkvalves.com.my",
                telephone: "+6016 699 5473",
                picture: ContactAVKSEA
            }
        ]
    }

    render() {
        const loc = this.props.location;
        const contactPerson = this.contactPersons[loc];

        return <Col className="d-flex flex-column botSpace" lg={this.props.lg}>
            <h2>{Strings.titleContactBlock}</h2>
            <Media className="block flex-fill">
                <Media body sm="auto" className="contactInfo">
                    <b>{contactPerson.name}</b><br/>
                    <i>{contactPerson.title}</i> <br/>
                    {Strings.contactPhone}
                    <a href={"tel:" + contactPerson.telephone.replace(/ /g, '')}>{contactPerson.telephone}</a>
                    <br/>
                    {Strings.contactEmail}<a href={"mailto:" + contactPerson.email}>{contactPerson.email}</a>
                </Media>
                <Media right>
                    <img src={contactPerson.picture} className="contactPicture" alt={contactPerson.name}/>
                </Media>
            </Media>
        </Col>
    }
}

ContactBlock.propTypes = {
    location: PropTypes.number.isRequired
};